import React, { useCallback, useEffect } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import Button from '@mui/material/Button'
import { useNavigate } from "@reach/router"
import BaseModal from './BaseModal';
import classes from './SubSuccessModal.module.scss'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


const SubSuccessModal = observer(({open, onClose}) => {
  const nav = useNavigate()

  return <BaseModal open={open} onClose={() => nav('/')} classes={classes}>
    <CheckCircleOutlineIcon className={classes.icon} />
    <div className={classes.text}>Your plan is confirmed</div>
    <div className={classes.text}>You now have access to your credits</div>
    <Button className={classes.browseAction} variant="contained" disableElevation onClick={() => nav('/')}>Continue to Browse</Button>
  </BaseModal>
})

export default SubSuccessModal;